import { render } from "./PublicAgentChat.vue?vue&type=template&id=b9ebf10e&scoped=true&ts=true"
import script from "./PublicAgentChat.vue?vue&type=script&lang=ts"
export * from "./PublicAgentChat.vue?vue&type=script&lang=ts"

import "./PublicAgentChat.vue?vue&type=style&index=0&id=b9ebf10e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ebf10e"]])

export default __exports__